/* eslint-disable  @typescript-eslint/no-explicit-any */

import { Col, Modal, Row } from 'react-bootstrap';
import Button from 'components/base/Button';
import {
  faClose
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ICFAnalysisView from '../../analytics/components/ICFAnalysisView';


interface AnalysisViewModalModalProps {
  analysis: string;
  handleClose: () => void;
  show: boolean;
}

const AnalysisViewModal = ({
  analysis,
  handleClose,
  show
}: AnalysisViewModalModalProps) => {


  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="xl"
      contentClassName="overflow-hidden"
    >
      <Modal.Header className="position-relative p-0">
        {/* <CoverImage handleClose={handleClose} /> */}
      </Modal.Header>
      <Modal.Body className="p-0">
        {/* <ActionSection /> */}

        <Row className="g-0">
          <Col xs={10} xl={10} className="border-300 bg-100">
            <div className="px-5 px-lg-6 py-4 bg-white">
              <h3 className="fw-bolder lh-sm mb-5">Feedback</h3>
            </div>
          </Col>

          <Col xs={2} xl={2} className=''>
            <div className="px-5 px-lg-6 py-4 bg-white " style={{ textAlign: 'end' }}>
              <Button variant="primary" className=" ms-auto" onClick={handleClose}>
                <FontAwesomeIcon icon={faClose} />
              </Button>
            </div>
          </Col>
        </Row>

        <ICFAnalysisView analysis={analysis} />

      </Modal.Body>
    </Modal>
  );
};

export default AnalysisViewModal;
